// NavTabs.jsx
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getNavTabs } from "./navTabsConfig";
import { quicksightReportsNavTabs } from "./navTabsQuicksightReportsExtension";
import { getUserPermission } from "../../lib";
import { userCanAccessTab } from "../../lib/appPermissions";

const NavTabs = ({
    settings,
    query,
    currentTab,
    demographicsCount = 0,
    conditionsCount = 0,
    tagsCount = 0,
    isAdvanced = false
}) => {
    if (isAdvanced) {
        return <ul className="nav nav-tabs" />;
    }

    const userScopes = getUserPermission();
    const tabs = [
        ...getNavTabs({
            counts: {
                demographicsCount,
                conditionsCount,
                tagsCount
            }
        }),
        ...quicksightReportsNavTabs
    ].filter((tab) => userCanAccessTab(userScopes, tab.permission));

    return (
        <ul className="nav nav-tabs">
            {tabs.map(tab => (
                <li key={tab.id} className={currentTab === tab.id ? "active" : null}>
                    <Link to={tab.href} onClick={tab.onClick}>
                        <b>{tab.label}</b>
                        {tab.badge ? (
                            <span className="hidden-xs">
                                {" "}
                                <small className="badge">{tab.badge}</small>
                            </span>
                        ) : null}
                    </Link>
                </li>
            ))}
        </ul>
    );
};

NavTabs.propTypes = {
    settings: PropTypes.object.isRequired,
    query: PropTypes.object.isRequired,
    currentTab: PropTypes.string,
    demographicsCount: PropTypes.number,
    conditionsCount: PropTypes.number,
    tagsCount: PropTypes.number,
    isAdvanced: PropTypes.bool
};

export default NavTabs;
